import React, { lazy, Suspense } from 'react'

import { Route, Routes } from 'react-router-dom'
import {
  AccountantsUrl,
  ComplianceOverviewUrl,
  ComplianceUrl,
  DashboardUrl,
  DataExportsUrl,
  PremiumUrl,
  ReportDetailUrl,
  ReportsUrl,
  TaxInfoUrl,
  TeamsFeatureUrl,
  TransactionsUrl,
  TripsUrl
} from 'constants/RouteUrls'
import LazyLoadingSkeleton from 'core/components/loaders/LazyLoadingSkeleton'
import NotFoundPage from 'routes/NotFoundPage'
import { lazyLoadHelper } from 'routes/resources'
import TaxInfoPage from 'pages/dashboard/tax-info/TaxInfoPage'

const HomePage = lazy(() =>
  lazyLoadHelper(import('pages/dashboard/home/HomePage'))
)
const TripsPage = lazy(() =>
  lazyLoadHelper(import('pages/dashboard/trips/TripsPage'))
)
const TransactionsPage = lazy(() =>
  lazyLoadHelper(import('pages/dashboard/transactions/TransactionsPage'))
)
const ReportsPage = lazy(() =>
  lazyLoadHelper(import('pages/dashboard/reports/ReportsPage'))
)
const DataExportPage = lazy(() =>
  lazyLoadHelper(import('pages/shared/data-export/DataExportPage'))
)
const TeamsFeaturesPage = lazy(() =>
  lazyLoadHelper(import('pages/dashboard/teams-features/TeamsFeaturesPage'))
)
const PremiumPage = lazy(() =>
  lazyLoadHelper(import('pages/shared/premium/PremiumPage'))
)
const ComplianceOverview = lazy(() =>
  lazyLoadHelper(
    import('pages/dashboard/compliance/overview/ComplianceOverview')
  )
)
const DriverFormPage = lazy(() =>
  lazyLoadHelper(
    import('pages/dashboard/compliance/driver-form/DriverFormPage')
  )
)
const AccountantsPage = lazy(() =>
  lazyLoadHelper(import('pages/dashboard/accountants/AccountantsPage'))
)
const ReportPageNew = lazy(() =>
  lazyLoadHelper(import('pages/shared/report/ReportPage'))
)

const PersonalDashboardRoutes = () => {
  return (
    <Routes>
      <Route
        path={DashboardUrl}
        element={
          <Suspense fallback={<LazyLoadingSkeleton variant="home" />}>
            <HomePage />
          </Suspense>
        }
      />
      <Route
        path={TripsUrl}
        element={
          <Suspense
            fallback={<LazyLoadingSkeleton variant="default" withBanner />}
          >
            <TripsPage />
          </Suspense>
        }
      />
      <Route
        path={TransactionsUrl}
        element={
          <Suspense
            fallback={<LazyLoadingSkeleton variant="default" withBanner />}
          >
            <TransactionsPage />
          </Suspense>
        }
      />
      <Route
        path={ReportsUrl}
        element={
          <Suspense fallback={<LazyLoadingSkeleton variant="default" />}>
            <ReportsPage />
          </Suspense>
        }
      />
      <Route
        path={DataExportsUrl}
        element={
          <Suspense fallback={<LazyLoadingSkeleton variant="default" />}>
            <DataExportPage />
          </Suspense>
        }
      />
      <Route
        path={ComplianceOverviewUrl}
        element={
          <Suspense fallback={<LazyLoadingSkeleton variant="default" />}>
            <ComplianceOverview />
          </Suspense>
        }
      />

      <Route
        path={TaxInfoUrl}
        element={
          <Suspense fallback={<LazyLoadingSkeleton variant="default" />}>
            <TaxInfoPage />
          </Suspense>
        }
      />

      <Route
        path={ComplianceUrl}
        element={
          <Suspense fallback={<LazyLoadingSkeleton variant="default" />}>
            <DriverFormPage />
          </Suspense>
        }
      />
      <Route
        path={AccountantsUrl}
        element={
          <Suspense fallback={<LazyLoadingSkeleton variant="default" />}>
            <AccountantsPage />
          </Suspense>
        }
      />
      <Route
        path={TeamsFeatureUrl}
        element={
          <Suspense fallback={<LazyLoadingSkeleton variant="teams-features" />}>
            <TeamsFeaturesPage />
          </Suspense>
        }
      />

      {/*This url will show the placeholder data, plans, FAQ, etc*/}
      <Route
        path={PremiumUrl}
        element={
          <Suspense fallback={<LazyLoadingSkeleton variant="premium" />}>
            <PremiumPage />
          </Suspense>
        }
      />

      {/*Excluded from side menu*/}
      <Route
        path={ReportDetailUrl}
        element={
          <Suspense
            fallback={<LazyLoadingSkeleton variant="report" isChildPage />}
          >
            <ReportPageNew />
          </Suspense>
        }
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

export default PersonalDashboardRoutes
